import { Fragment } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Link from "next/link";

const schema = yup
  .object({
    code: yup
      .string()
      .length(6, "Code must be 6 characters long")
      .required("Please enter a code"),
  })
  .required();

export default function LegacyCode({ loadingAuth, onCodeSubmit }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <Fragment>
      <div>We've sent a code to your email. Please enter the code below</div>
      <form
        className="mt-8 space-y-6"
        onSubmit={handleSubmit((data) => onCodeSubmit(data))}
      >
        <div className="relative space-y-2">
          <div>
            <label
              htmlFor="code"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Code
            </label>
            <div className="mt-1 relative">
              <input
                id="code"
                name="code"
                type="text"
                {...register("code")}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            {errors.code && (
              <div className="flex items-center pointer-events-none mt-2 text-red-600">
                <svg
                  className="h-5 w-5 text-red-500 mr-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
                {errors.code.message}
              </div>
            )}
          </div>
        </div>

        <div>
          <button
            type="submit"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primaryDark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
              {/* <!-- Heroicon name: solid/lock-closed --> */}
              <svg
                className="h-5 w-5 text-primaryDark group-hover:text-primary"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
            {loadingAuth
              ? "Loading..."
              : // <Loader height="5" width="5" color="white" />
                "Verify code"}
          </button>
        </div>
        <div>
          <p className="mt-2 text-center text-sm text-gray-600">
            <Link href="/signin">
              <span className="font-medium text-primaryDark hover:text-primary">
                Just want to sign in?
              </span>
            </Link>
          </p>
        </div>
      </form>
    </Fragment>
  );
}
